import type { LoadState } from './workflowShared';

interface GitHubProfileMenuProps {
  githubSessionId: string;
  githubLogin: string;
  githubConfigState: LoadState;
  githubSessionState: LoadState;
  githubRepositoriesState: LoadState;
  onRefreshGitHubAccess: () => void;
}

function HeaderProfileIcon() {
  return (
    <svg className="profile-trigger-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 12.25a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 1.75c-4.14 0-7.5 2.26-7.5 5.05 0 .66.54 1.2 1.2 1.2h12.6c.66 0 1.2-.54 1.2-1.2 0-2.79-3.36-5.05-7.5-5.05Z"
      />
    </svg>
  );
}

function HeaderRefreshIcon() {
  return (
    <svg className="button-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M18.65 7.35A8 8 0 1 0 20 12h-2a6 6 0 1 1-1.76-4.24L13 11h8V3l-2.35 4.35Z"
      />
    </svg>
  );
}

function GitHubProfileMenu({
  githubSessionId,
  githubLogin,
  githubConfigState,
  githubSessionState,
  githubRepositoriesState,
  onRefreshGitHubAccess
}: GitHubProfileMenuProps) {
  const isLoggedIn = Boolean(githubSessionId);
  const isRefreshing =
    githubConfigState === 'loading' ||
    githubSessionState === 'loading' ||
    githubRepositoriesState === 'loading';

  return (
    <details className="profile-menu">
      <summary className="profile-trigger" aria-label="GitHub profile menu">
        <HeaderProfileIcon />
      </summary>
      <div className="profile-dropdown">
        <div className="profile-status">
          <span className={`profile-status-dot ${isLoggedIn ? 'connected' : ''}`} aria-hidden="true" />
          <div>
            <strong>{isLoggedIn ? 'Logged in with GitHub' : 'Not logged in with GitHub'}</strong>
            <span>{isLoggedIn ? (githubLogin ? githubLogin : 'Account connected') : 'No GitHub account connected'}</span>
          </div>
        </div>
        <button type="button" className="profile-menu-action" onClick={onRefreshGitHubAccess}>
          <HeaderRefreshIcon />
          <span>{isRefreshing ? 'Refreshing' : 'Refresh'}</span>
        </button>
      </div>
    </details>
  );
}

export default GitHubProfileMenu;
